import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { postData, fetchData, updateData } from '../../../apiService';
import Select from 'react-select';
import AsyncCreatableSelect from 'react-select/async-creatable';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import './Create.css';
import AsyncSelect from "react-select/async";

const PurchaseOrderCreate = () => {
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const { token, userId, companyId, isAuthenticated, logout } = useAuth();

    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');
    const [durationTypes, setDurationTypes] = useState([]);
    const [dateValidationWarning, setDateValidationWarning] = useState('');
    const [subcontractOptions, setsubcontractOptions] = useState([]);
    const [statesList, setStatesList] = useState([]);
    const [supplierOptions, setSupplierOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);

    const [showAMC, setShowAMC] = useState(false);
    const [showStamping, setShowStamping] = useState(false);
    const [isRenewalOrder, setIsRenewalOrder] = useState(false);
    const [renewalDataLoaded, setRenewalDataLoaded] = useState(false);
    const [originalOrderId, setOriginalOrderId] = useState(null);

    const [formData, setFormData] = useState({
        Id: 0,
        CompanyId: companyId,
        CustomerId: "",
        PONumber: "",
        FinYear: new Date().getFullYear().toString(),
        PODate: new Date().toISOString().split("T")[0],
        StampTypeId: "",
        StampingFromDate: "",
        StampingToDate: "",
        AMCTypeId: "",
        AMCFromDate: "",
        AMCToDate: "",
        SubcontractId: "",
        SubcontractName: "",
        StateId: "",
        StateName: "",
        StampingStatusId: 1,
        AmcStatusId: 1,
        IsActive: true,
        CreatedDate: new Date().toISOString().split("T")[0],
        CreatedBy: userId,
        UpdatedDate: new Date().toISOString().split("T")[0],
        UpdatedBy: userId
    });

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
        }
        
        // Load data in sequence to ensure proper initialization
        const loadInitialData = async () => {
            await fetchDurationTypes();
            await fetchStatesAndSubcontracts();
            await fetchmaxbillno();
        };
        
        loadInitialData();
    }, [isAuthenticated, token]);

    const loadRenewalDataWithOptions = async (subcontractOpts = null) => {
        const renewalDataStr = localStorage.getItem('renewalOrderData');
        if (renewalDataStr && !renewalDataLoaded) {
            setRenewalDataLoaded(true);
            const availableSubcontractOptions = subcontractOpts || subcontractOptions;
            try {
                const renewalData = JSON.parse(renewalDataStr);
                console.log('Loading renewal data:', renewalData);
                console.log('originalOrder:', renewalData.originalOrder);
                
                setIsRenewalOrder(true);
                setOriginalOrderId(renewalData.originalOrderId);
                
                // Wait a bit for options to load
                setTimeout(() => {
                    // Set customer selection
                    if (renewalData.customerId && renewalData.customerName) {
                        const customerOption = {
                            value: renewalData.customerId,
                            label: renewalData.customerName,
                            stateId: renewalData.stateId || '',
                            stateName: renewalData.stateName || ''
                        };
                        setSelectedCustomer(customerOption);
                        console.log('Setting customer:', customerOption);
                        
                        // Also trigger customer selection to populate state
                        handleCustomerSelect(customerOption);
                    }

                    // Calculate stamping dates (from today, to one year minus one day)
                    const fromDate = new Date();
                    const toDate = new Date(fromDate);
                    toDate.setFullYear(toDate.getFullYear() + 1);
                    toDate.setDate(toDate.getDate() - 1);

                    const formattedFromDate = fromDate.toISOString().split('T')[0];
                    const formattedToDate = toDate.toISOString().split('T')[0];

                    // Update form data with renewal information
                    setFormData(prev => ({
                        ...prev,
                        CustomerId: renewalData.customerId || '',
                        SubcontractId: renewalData.subcontractId ? renewalData.subcontractId.toString() : '',
                        StateId: renewalData.stateId || '',
                        StateName: renewalData.stateName || '',
                        StampingFromDate: formattedFromDate,
                        StampingToDate: formattedToDate,
                        AMCFromDate: formattedFromDate,
                        AMCToDate: formattedToDate,
                        AMCTypeId: renewalData.amcTypeId || renewalData.originalOrder?.AMCTypeId || '' // Set AMC Type ID from renewal data or original order
                    }));

                    console.log('Setting subcontract ID:', renewalData.subcontractId);
                    console.log('Available subcontract options:', availableSubcontractOptions.length);
                    console.log('Setting AMC Type ID:', renewalData.amcTypeId || renewalData.originalOrder?.AMCTypeId);
                    console.log('Available duration types:', durationTypes.length);

                    // Set subcontractor if ID is available and options are loaded
                    if (renewalData.subcontractId && availableSubcontractOptions.length > 0) {
                        const matchingSubcontract = availableSubcontractOptions.find(opt => 
                            opt.value === parseInt(renewalData.subcontractId, 10)
                        );
                        if (matchingSubcontract) {
                            console.log('Found matching subcontract:', matchingSubcontract);
                            console.log('Subcontract state info:', {
                                stateId: matchingSubcontract.stateId,
                                stateName: matchingSubcontract.stateName
                            });
                            
                            // Set subcontract and its state directly
                            setFormData(prev => {
                                const newFormData = {
                                    ...prev,
                                    SubcontractId: renewalData.subcontractId.toString(),
                                    SubcontractName: matchingSubcontract.subcontractName || '',
                                    StateId: matchingSubcontract.stateId || prev.StateId,
                                    StateName: matchingSubcontract.stateName || prev.StateName
                                };
                                console.log('Setting form data with subcontract:', newFormData);
                                return newFormData;
                            });
                            
                            console.log('Set subcontract and state:', {
                                subcontractId: renewalData.subcontractId,
                                stateName: matchingSubcontract.stateName
                            });
                        } else {
                            console.log('No matching subcontract found for ID:', renewalData.subcontractId);
                            console.log('Available subcontract IDs:', availableSubcontractOptions.map(opt => opt.value));
                        }
                    }

                    // Override state with renewal data if available (after a short delay)
                    setTimeout(() => {
                        if (renewalData.stateName) {
                            setFormData(prev => ({
                                ...prev,
                                StateName: renewalData.stateName,
                                StateId: renewalData.stateId || prev.StateId
                            }));
                            console.log('Setting state name from renewal data:', renewalData.stateName);
                        }
                    }, 200);

                    // Show relevant sections and set AMC type after duration types are loaded
                    if (renewalData.hasStamping) {
                        setShowStamping(true);
                        console.log('Showing stamping section');
                    }
                    if (renewalData.hasAMC) {
                        setShowAMC(true);
                        console.log('Showing AMC section');
                        
                        // Set AMC Type after a delay to ensure duration types are loaded
                        setTimeout(() => {
                            const amcTypeId = renewalData.amcTypeId || renewalData.originalOrder?.AMCTypeId;
                            if (amcTypeId && durationTypes.length > 0) {
                                console.log('Setting AMC Type ID after delay:', amcTypeId);
                                console.log('Available duration types:', durationTypes);
                                console.log('Looking for duration type with value:', amcTypeId);
                                const matchingDurationType = durationTypes.find(x => x.value === parseInt(amcTypeId, 10));
                                console.log('Found matching duration type:', matchingDurationType);
                                
                                setFormData(prev => {
                                    const newFormData = {
                                        ...prev,
                                        AMCTypeId: amcTypeId.toString()
                                    };
                                    console.log('Setting AMC Type in form data:', newFormData.AMCTypeId);
                                    return newFormData;
                                });
                            } else {
                                console.log('AMC Type not set - amcTypeId:', amcTypeId, 'durationTypes length:', durationTypes.length);
                            }
                        }, 500);
                    }

                    console.log(`Renewal order loaded: From ${formattedFromDate} to ${formattedToDate}`);
                }, 1000); // Wait 1 second for options to load

                // Clear the renewal data from localStorage
                localStorage.removeItem('renewalOrderData');
                
            } catch (error) {
                console.error('Error loading renewal data:', error);
                localStorage.removeItem('renewalOrderData');
            }
        }
    };

    // Fallback function for compatibility
    const loadRenewalData = () => {
        loadRenewalDataWithOptions();
    };

    // Monitor when both duration types and subcontract options are loaded to trigger renewal data loading
    useEffect(() => {
        if (durationTypes.length > 0 && subcontractOptions.length > 0 && !renewalDataLoaded) {
            console.log('Both duration types and subcontract options loaded, checking for renewal data...');
            const renewalDataStr = localStorage.getItem('renewalOrderData');
            if (renewalDataStr) {
                console.log('Renewal data found, loading...');
                loadRenewalDataWithOptions(subcontractOptions);
            }
        }
    }, [durationTypes, subcontractOptions, renewalDataLoaded]);

    // Function to update original order renewal status
    const updateOriginalOrderRenewalStatus = async (orderId) => {
        try {
            console.log('Updating original order renewal status for ID:', orderId);
            
            // Option 1: Use a specific renewal status update endpoint
            const response = await postData(`PurchaseOrder/${orderId}/SetRenewalStatus`, { IsRenewed: true }, token);
            
            // Option 2: Alternative - use a PUT request to update the order
            // const response = await updateData('PurchaseOrder', orderId, { IsRenewed: true }, token);
            
            console.log('Original order renewal status updated:', response);
            return response;
        } catch (error) {
            console.error('Error updating original order renewal status:', error);
            // Don't throw error - renewal creation was successful, this is just a status update
            return null;
        }
    };

    const fetchStatesAndSubcontracts = async () => {
        try {
            // First fetch states
            const statesResponse = await fetchData('SubContractAPI', `/State/${companyId}`, token);
            if (statesResponse.responseCode === '1111') {
                setStatesList(statesResponse.response_data);
                console.log('States loaded:', statesResponse.response_data);

                // Then fetch subcontracts and map with state names
                const subcontractResponse = await fetchData('SubContractAPI', `/${companyId}`, token);
                if (subcontractResponse.responseCode === '1111') {
                    console.log('Subcontracts loaded:', subcontractResponse.response_data);

                    const options = subcontractResponse.response_data.map(subcontract => {
                        const state = statesResponse.response_data.find(s => s.Id === subcontract.StateId);
                        // Use state name from lookup, or fallback to direct State field from subcontractor
                        const stateName = state ? state.Name : (subcontract.State || '');

                        console.log(`Mapping: ${subcontract.Name} -> StateId: ${subcontract.StateId} -> StateName: ${stateName} (Direct State: ${subcontract.State})`);

                        return {
                            value: subcontract.Id,
                            label: subcontract.Name,
                            subcontractName: subcontract.Name,
                            stateId: subcontract.StateId,
                            stateName: stateName
                        };
                    });
                    setsubcontractOptions(options);
                    console.log('Subcontract options set:', options.length, 'options');
                    
                    // Load renewal data after both subcontract options and duration types are loaded
                    setTimeout(() => {
                        console.log('About to load renewal data, subcontract options available:', options.length);
                        console.log('Duration types available:', durationTypes.length);
                        loadRenewalDataWithOptions(options);
                    }, 800); // Increased delay to ensure duration types are loaded
                }
            }
        } catch (error) {
            console.error('Error fetching states and subcontracts:', error);
        }
    };


    const fetchDurationTypes = async () => {
        try {
            console.log('Fetching duration types...');
            const response = await fetchData('PurchaseOrder', `/DurationType/${companyId}`, token);
            console.log('Duration Types Response:', response);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(durationType => ({
                    value: durationType.Id,
                    label: durationType.DurationTypes
                }));
                console.log('Duration Types Options:', options);
                setDurationTypes(options);
            } else {
                console.error('Duration Types Response Code:', response.responseCode);
            }
        } catch (error) {
            console.error('Error fetching duration types:', error);
        }
    };


    const fetchmaxbillno = async () => {
        try {
            console.log('Fetching Max Bill Number for Company:', companyId);
            const response = await fetchData('MastersAPI', `/MaxBillno/${companyId}`, token);
            console.log('Max Bill Number Response:', response);

            if (response && response.response_data) {
                const data = response.response_data;
                console.log('FinYear from API:', data.FinYear);

                const currentDate = new Date();
                const year = currentDate.getFullYear();
                const month = String(currentDate.getMonth() + 1).padStart(2, '0');
                const day = String(currentDate.getDate()).padStart(2, '0');
                const formattedDate = `${year}-${month}-${day}`;

                // PONumber is intentionally left blank for manual entry - no default value
                setFormData(prevData => ({
                    ...prevData,
                    PONumber: '', // Manual entry required - no default value
                    PODate: formattedDate,
                    FinYear: data.FinYear || year.toString(),
                    CompanyId: companyId,
                }));

                console.log('Form data initialized - PONumber left blank for manual entry');
            } else {
                console.error('Invalid response format:', response);
            }
        } catch (error) {
            console.error('Error fetching Max Billno:', error);
        }
    };

    const fetchOptions = async (inputValue) => {
        if (inputValue.length <= 2) {
            return [];
        }
        try {
            const response = await fetchData('MastersAPI', `/Customer/${companyId}/${inputValue}`, token);
            if (response.responseCode === '1111') {
                const data = await response.response_data;

                if (Array.isArray(data)) {
                    setSupplierOptions(data);
                    
                    // Convert to options format
                    const options = data.map(item => ({
                        value: item.id,
                        label: item.name,
                        stateId: item.stateId || item.StateId || '',
                        stateName: item.stateName || item.StateName || '',
                    }));

                    // Sort options: exact matches starting with input first, then others
                    const sortedOptions = options.sort((a, b) => {
                        const aName = a.label.toLowerCase();
                        const bName = b.label.toLowerCase();
                        const searchTerm = inputValue.toLowerCase();

                        // Check if names start with the search term
                        const aStartsWith = aName.startsWith(searchTerm);
                        const bStartsWith = bName.startsWith(searchTerm);

                        // Prioritize items that start with the search term
                        if (aStartsWith && !bStartsWith) return -1;
                        if (!aStartsWith && bStartsWith) return 1;

                        // If both start with search term or both don't, sort alphabetically
                        return aName.localeCompare(bName);
                    });

                    console.log(`Customer search for "${inputValue}": ${sortedOptions.length} results, prioritizing exact matches`);
                    return sortedOptions;
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching options:', error);
            return [];
        }
    };

    const handleCustomerSelect = (selectedOption) => {
        console.log('Customer selected:', selectedOption);
        setSelectedCustomer(selectedOption);

        if (selectedOption) {
            if (selectedOption.__isNew__) {
                setFormData((prevData) => ({
                    ...prevData,
                    CustomerId: selectedOption.label,
                    StateId: '',
                    StateName: '',
                    CreatedBy: userId,
                }));
            } else {
                // Auto-populate State from Customer data
                setFormData((prevData) => ({
                    ...prevData,
                    CustomerId: selectedOption.value,
                    StateId: selectedOption.stateId || '',
                    StateName: selectedOption.stateName || '',
                    CreatedBy: userId,
                }));
            }
        } else {
            setFormData((prevData) => ({
                ...prevData,
                CustomerId: '',
                StateId: '',
                StateName: '',
                CreatedBy: userId,
            }));
        }
    };

    const handleInputChange = (input) => input;

    const handleChange = (e) => {
        const { name, value } = e.target;
        
        // Clear date validation warning when user changes any date fields
        if (name === 'PODate' || name === 'StampingFromDate' || name === 'StampingToDate' || name === 'AMCFromDate' || name === 'AMCToDate') {
            setDateValidationWarning('');
        }
        
        setFormData(prev => ({ ...prev, [name]: value }));

        // Auto-calculate StampingToDate and AMC dates when StampingFromDate changes
        if (name === 'StampingFromDate' && value) {
            const fromDate = new Date(value);
            if (!isNaN(fromDate.getTime())) {
                // Add one year and subtract one day
                const toDate = new Date(fromDate);
                toDate.setFullYear(toDate.getFullYear() + 1);
                toDate.setDate(toDate.getDate() - 1);
                
                // Format as YYYY-MM-DD for input field
                const formattedToDate = toDate.toISOString().split('T')[0];
                
                setFormData(prev => ({
                    ...prev,
                    StampingFromDate: value,
                    StampingToDate: formattedToDate,
                    // Also set AMC dates to the same values
                    AMCFromDate: value,
                    AMCToDate: formattedToDate
                }));
                
                console.log(`Stamping From Date: ${value} -> To Date: ${formattedToDate}`);
                console.log(`AMC dates also set: From ${value} -> To ${formattedToDate}`);
                return; // Exit early since we've already updated formData
            }
        }

        if (name === 'SubcontractId' && value) {
            const selectedSubcontract = subcontractOptions.find(opt => opt.value === parseInt(value, 10));
            console.log('Selected Subcontract:', selectedSubcontract);
            if (selectedSubcontract) {
                setFormData(prev => ({
                    ...prev,
                    SubcontractId: value,
                    SubcontractName: selectedSubcontract.subcontractName || '',
                    // Also populate state from subcontractor if not already set from customer
                    StateId: selectedSubcontract.stateId || prev.StateId,
                    StateName: selectedSubcontract.stateName || prev.StateName
                }));
                console.log('Setting state from subcontractor:', selectedSubcontract.stateName);
            }
        }
    };

    // Year validation function
    const validateDateYear = (dateString, fieldName) => {
        if (!dateString) return true;
        
        const year = new Date(dateString).getFullYear();
        const currentYear = new Date().getFullYear();
        
        // Check for obviously wrong years (like 0020 instead of 2025)
        if (year < 1900 || year > 2100) {
            setDateValidationWarning(`${fieldName} year "${year}" seems incorrect. Please verify the year is correct before submitting.`);
            return false;
        }
        
        // Check for years that are too far in the past or future
        if (year < currentYear - 10 || year > currentYear + 10) {
            setDateValidationWarning(`${fieldName} year "${year}" is unusual. Please confirm this is the correct year.`);
            return false;
        }
        
        return true;
    };

    const submitData = async () => {
        setIsLoading(true);
        setErrorMessage('');
        setDateValidationWarning('');

        if (!formData.CustomerId) {
            setErrorMessage("Please select a customer!");
            setIsLoading(false);
            return;
        }

        if (!formData.PONumber) {
            setErrorMessage("Please enter PO Number!");
            setIsLoading(false);
            return;
        }

        // Validate date years before submission
        let hasDateValidationError = false;
        
        if (formData.PODate && !validateDateYear(formData.PODate, "PO Date")) {
            hasDateValidationError = true;
        }
        
        if (formData.StampingFromDate && !validateDateYear(formData.StampingFromDate, "Stamping From Date")) {
            hasDateValidationError = true;
        }
        
        if (formData.StampingToDate && !validateDateYear(formData.StampingToDate, "Stamping To Date")) {
            hasDateValidationError = true;
        }
        
        if (formData.AMCFromDate && !validateDateYear(formData.AMCFromDate, "AMC From Date")) {
            hasDateValidationError = true;
        }
        
        if (formData.AMCToDate && !validateDateYear(formData.AMCToDate, "AMC To Date")) {
            hasDateValidationError = true;
        }
        
        if (hasDateValidationError) {
            setIsLoading(false);
            return;
        }

        // Use default date (1900-01-01) for empty date fields as per C# model requirements
        const defaultDate = "1900-01-01";

        const dataToSubmit = {
            Id: 0,
            CompanyId: parseInt(companyId, 10),
            CustomerId: parseInt(formData.CustomerId, 10),
            PONumber: formData.PONumber,
            FinYear: formData.FinYear,
            PODate: formData.PODate,
            StampTypeId: parseInt(formData.StampTypeId, 10) || 0,
            StampingFromDate: formData.StampingFromDate || defaultDate,
            StampingToDate: formData.StampingToDate || defaultDate,
            AMCTypeId: parseInt(formData.AMCTypeId, 10) || 0,
            AMCFromDate: formData.AMCFromDate || defaultDate,
            AMCToDate: formData.AMCToDate || defaultDate,
            SubcontractorId: parseInt(formData.SubcontractId, 10) || 0,
            StateId: parseInt(formData.StateId, 10) || 0,
            IsServiceCompleted: false,
            IsStampingCompleted: false,
            IsActive: true,
            CreatedDate: new Date().toISOString().split("T")[0],
            CreatedBy: parseInt(userId, 10),
            UpdatedDate: new Date().toISOString().split("T")[0],
            UpdatedBy: parseInt(userId, 10),
            IsRenewal: false // New renewal orders are regular orders, not marked as renewals
        };


        console.log('Submitting Purchase Order:', dataToSubmit);

        try {
            const response = await postData("PurchaseOrder", dataToSubmit, token);
            console.log('Purchase Order Created:', response);
            
            // If this is a renewal order and creation was successful, update original order status
            if (isRenewalOrder && originalOrderId && response) {
                console.log('Renewal order created successfully, updating original order status...');
                const renewalStatusUpdate = await updateOriginalOrderRenewalStatus(originalOrderId);
                
                if (renewalStatusUpdate) {
                    alert('Renewal order created successfully! Original order has been marked as renewed.');
                } else {
                    alert('Renewal order created successfully! (Note: Could not update original order status)');
                }
            } else if (response) {
                alert('Purchase order created successfully!');
            }
            
            history.push("/PurchaseOrderIndex");
        } catch (error) {
            console.error('Error creating purchase order:', error);
            if (error.response && error.response.data) {
                const apiError = error.response.data;
                if (apiError.message) {
                    setErrorMessage(apiError.message);
                } else if (apiError.errors) {
                    const errorMessages = Object.values(apiError.errors).flat().join(', ');
                    setErrorMessage(errorMessages);
                } else {
                    setErrorMessage("Failed to create purchase order!");
                }
            } else {
                setErrorMessage("Failed to create purchase order! Please check if the API endpoint exists.");
            }
        }
        setIsLoading(false);
    };

    return (
        <div className="po-page-wrapper">
            <div className="po-page-header">
                <div className="header-left">
                    <h1 className="page-title">
                        {isRenewalOrder ? 'Create Renewal Order' : 'Create Purchase Order'}
                    </h1>
                    <p className="page-subtitle">
                        {isRenewalOrder ? 'Renewing existing contract with updated dates' : 'Manage stamping and service contracts'}
                    </p>
                </div>
                <div className="header-actions">
                    <Button
                        variant="outlined"
                        component={Link}
                        to="/PurchaseOrderIndex"
                        className="btn-cancel"
                        sx={{ color: '#ffffff !important' }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={submitData}
                        disabled={isLoading}
                        className="btn-save"
                        startIcon={isLoading ? <CircularProgress size={18} color="inherit" /> : null}
                    >
                        {isLoading ? "Saving..." : "Save Order"}
                    </Button>
                </div>
            </div>

            {errorMessage && (
                <div className="alert-error">
                    <svg className="alert-icon" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                    </svg>
                    <span>{errorMessage}</span>
                </div>
            )}

            {dateValidationWarning && (
                <div className="alert-warning" style={{
                    backgroundColor: '#fef3c7',
                    border: '1px solid #f59e0b',
                    borderRadius: '6px',
                    padding: '12px 16px',
                    margin: '16px 0',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    color: '#92400e'
                }}>
                    <svg className="alert-icon" fill="currentColor" viewBox="0 0 20 20" style={{ width: '20px', height: '20px', flexShrink: 0 }}>
                        <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                    </svg>
                    <span>{dateValidationWarning}</span>
                </div>
            )}

            <div className="po-content">
                <div className="form-section">
                    <div className="section-content">
                        <div className="form-row first-row">
                            <div className="form-group">
                                <label className="form-label">
                                    Customer <span className="required">*</span>
                                </label>
                                <AsyncCreatableSelect
                                    classNamePrefix="select"
                                    loadOptions={fetchOptions}
                                    onChange={handleCustomerSelect}
                                    value={selectedCustomer}
                                    onInputChange={handleInputChange}
                                    placeholder="Search or create customer..."
                                    isClearable
                                    menuPlacement="auto"
                                    menuPosition="fixed"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        menu: base => ({ ...base, zIndex: 9999 }),
                                        control: (base) => ({
                                            ...base,
                                            height: 38,
                                            minHeight: 38
                                        }),
                                    }}
                                />
                            </div>

                            <div className="form-group">
                                <label className="form-label">
                                    PO Number <span className="required">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="PONumber"
                                    className="form-control"
                                    value={formData.PONumber}
                                    onChange={handleChange}
                                    placeholder="Enter PO Number"
                                />
                            </div>

                            <div className="form-group">
                                <label className="form-label">
                                    PO Date <span className="required">*</span>
                                </label>
                                <input
                                    type="date"
                                    name="PODate"
                                    className="form-control"
                                    value={formData.PODate}
                                    onChange={handleChange}
                                    onBlur={(e) => {
                                        if (e.target.value) {
                                            validateDateYear(e.target.value, "PO Date");
                                        }
                                    }}
                                />
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label className="form-label">Subcontract</label>
                                <select
                                    name="SubcontractId"
                                    className="form-control"
                                    value={formData.SubcontractId}
                                    onChange={handleChange}
                                >
                                    <option value="">Select Subcontract</option>
                                    {subcontractOptions.map((item) => (
                                        <option key={item.value} value={item.value}>
                                            {item.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="form-group">
                                <label className="form-label">State</label>
                                <input
                                    type="text"
                                    name="StateName"
                                    className="form-control"
                                    value={formData.StateName || ''}
                                    readOnly
                                    placeholder="Auto-populated from Customer"
                                    style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                                />
                            </div>
                        </div>

                        <div className="form-row" style={{ marginTop: '20px', marginBottom: '20px' }}>
                            <div className="form-group">
                                <label className="form-label" style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}>
                                    <input
                                        type="checkbox"
                                        checked={showStamping}
                                        onChange={(e) => setShowStamping(e.target.checked)}
                                        style={{ width: '18px', height: '18px', cursor: 'pointer', accentColor: '#667eea' }}
                                    />
                                    <span>Stamping (Legal Metrology)</span>
                                </label>
                            </div>

                            <div className="form-group">
                                <label className="form-label" style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}>
                                    <input
                                        type="checkbox"
                                        checked={showAMC}
                                        onChange={(e) => setShowAMC(e.target.checked)}
                                        style={{ width: '18px', height: '18px', cursor: 'pointer', accentColor: '#667eea' }}
                                    />
                                    <span>AMC (Annual Maintenance Contract)</span>
                                </label>
                            </div>
                        </div>

                        {(showStamping || showAMC) && (
                            <div className="date-range-container">
                                {showStamping && (
                                    <div className="date-range-group">
                                        <h3 className="range-title">Stamping Details</h3>
                                        <div className="form-row-vertical">
                                            <div className="form-group">
                                                <label className="form-label">Stamping Type</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value="Yearly"
                                                    readOnly
                                                    style={{ backgroundColor: '#f1f5f9', cursor: 'not-allowed', fontWeight: '600' }}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label className="form-label">From Date</label>
                                                <input
                                                    type="date"
                                                    name="StampingFromDate"
                                                    className="form-control"
                                                    value={formData.StampingFromDate}
                                                    onChange={handleChange}
                                                    onBlur={(e) => {
                                                        if (e.target.value) {
                                                            validateDateYear(e.target.value, "Stamping From Date");
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label className="form-label">To Date</label>
                                                <input
                                                    type="date"
                                                    name="StampingToDate"
                                                    className="form-control"
                                                    value={formData.StampingToDate}
                                                    onChange={handleChange}
                                                    onBlur={(e) => {
                                                        if (e.target.value) {
                                                            validateDateYear(e.target.value, "Stamping To Date");
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {showAMC && (
                                    <div className="date-range-group">
                                        <h3 className="range-title">AMC Details</h3>
                                        <div className="form-row-vertical">
                                            <div className="form-group">
                                                <label className="form-label">AMC Type</label>
                                                <Select
                                                    classNamePrefix="select"
                                                    options={durationTypes}
                                                    value={durationTypes.find(x => x.value === parseInt(formData.AMCTypeId, 10)) || null}
                                                    onChange={(opt) =>
                                                        setFormData(prev => ({ ...prev, AMCTypeId: opt ? opt.value : '' }))
                                                    }
                                                    placeholder="Select AMC type..."
                                                    isClearable
                                                    menuPlacement="auto"
                                                    menuPosition="fixed"
                                                    menuPortalTarget={document.body}
                                                    styles={{
                                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                        menu: base => ({ ...base, zIndex: 9999 }),
                                                        control: (base) => ({
                                                            ...base,
                                                            height: 38,
                                                            minHeight: 38
                                                        }),
                                                    }}
                                                />
                                                <span className="field-hint">Reminder will be sent before expiry</span>
                                            </div>
                                            <div className="form-group">
                                                <label className="form-label">From Date</label>
                                                <input
                                                    type="date"
                                                    name="AMCFromDate"
                                                    className="form-control"
                                                    value={formData.AMCFromDate}
                                                    onChange={handleChange}
                                                    onBlur={(e) => {
                                                        if (e.target.value) {
                                                            validateDateYear(e.target.value, "AMC From Date");
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label className="form-label">To Date</label>
                                                <input
                                                    type="date"
                                                    name="AMCToDate"
                                                    className="form-control"
                                                    value={formData.AMCToDate}
                                                    onChange={handleChange}
                                                    onBlur={(e) => {
                                                        if (e.target.value) {
                                                            validateDateYear(e.target.value, "AMC To Date");
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PurchaseOrderCreate;
